<script setup>
import { computed } from "vue";

const props = defineProps({
  size: {
    type: String,
    default: "medium",
    validator: (value) => ["extra-small", "small", "medium", "large"].includes(value)
  },
  pressed: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  iconOnly: {
    type: Boolean,
    default: false
  }
});

const buttonClasses = computed(() => [
  "button-neutral-tertiary",
  `button-neutral-tertiary--${props.size}`,
  {
    "button-neutral-tertiary--icon-only": props.iconOnly,
    "button-neutral-tertiary--pressed": props.pressed
  }
]);
</script>

<template>
  <button
    :disabled="props.disabled"
    :class="buttonClasses"
    :aria-pressed="props.pressed ? 'true' : 'false'"
    type="button"
  >
    <slot name="icon-left" />
    <slot />
    <slot name="icon-right" />
  </button>
</template>

<style scoped lang="scss">

.button-neutral-tertiary {
  // Сброс дефолтных стилей.
  outline: none;
  background: none;
  margin: 0;
  font: inherit;

  // Стили кнопки.
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: center;
  padding: 6px 15px;
  background: var(--button-tertiary-neutral-bd-default);
  color: var(--button-tertiary-neutral-text);
  border: 1px solid var(--button-tertiary-neutral-bd-default);
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;

  cursor: pointer;
  user-select: none;

  // Если кнопка содержит только иконку - убираем отступы, задаем ширину равной высоте.
  &--icon-only {
    padding: 0;
    min-width: var(--button-height);
    width: var(--button-height);
  }

  // Состояния

  &:hover:not(:disabled):not(&--pressed) {
    background: var(--button-tertiary-neutral-hover);
    border-color: var(--button-tertiary-neutral-hover);
  }

  &:focus-visible {
    outline: 2px solid var(--button-tertiary-neutral-bd-focused);
    outline-offset: 2px;
  }

  &:disabled {
    pointer-events: none;
    background: transparent;
    color: var(--text-text-disabled);
    border-color: var(--button-tertiary-neutral-bd-disabled);
  }

  &--pressed {
    pointer-events: none;
    color: var(--button-tertiary-neutral-text);
    background: var(--button-tertiary-neutral-pressed);
    border-color: var(--button-tertiary-neutral-pressed);
  }


  // Размеры
  &--extra-small {
    --button-height: 24px;
    height: var(--button-height);
    min-height: var(--button-height);
  }

  &--small {
    --button-height: 30px;
    height: var(--button-height);
    min-height: var(--button-height);
  }

  &--medium {
    --button-height: 36px;
    height: var(--button-height);
    min-height: var(--button-height);
  }

  &--large {
    --button-height: 42px;
    height: var(--button-height);
    min-height: var(--button-height);
  }
}

</style>